import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerifyPatientComponent } from './verify-patient/verify-patient.component';
import { UpdateRecordComponent } from './update-record/update-record.component';
import { SymptomsComponent } from './symptoms/symptoms.component';
import { InusrancesComponent } from './inusrances/inusrances.component';
import { CareTeamComponent } from './care-team/care-team.component';
import { CovidFormComponent } from './covid-form/covid-form.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { ConsentformComponent } from './consentform/consentform.component';
import { FinancialFormComponent } from './financial-form/financial-form.component';
import { SymptomsMaleComponent } from './symptoms-male/symptoms-male.component';
import { FollowupComponent } from './followup/followup.component';
import { SymptomsquestionsComponent } from './symptoms/symptomsquestions/symptomsquestions.component';
import { VisitReasonComponent } from './visit-reason/visit-reason.component';
import { PaymentOverviewComponent } from './payment-overview/payment-overview.component';
import { PaymentComponent } from './payment/payment.component';

const routes: Routes = [
  {
    path: 'patient',
    children: [
      {
        path: 'verifypatient',
        component: VerifyPatientComponent
      },
      {
        path: 'updateinfo',
        component: UpdateRecordComponent
      },
      {
        path: 'symptomsfemale',
        component: SymptomsComponent
      },
      {
        path: 'symptomsmale',
        component: SymptomsMaleComponent
      },
      {
        path: 'symptomsquestion',
        component: SymptomsquestionsComponent
      },
      {
        path: 'symptoms-follow-up',
        component: FollowupComponent
      },
      {
        path: 'intake',
        loadChildren: () => import('./intakemodule/intakemodule.module').then(m => m.IntakemoduleModule)
      },
      {
        path: 'insurance',
        component: InusrancesComponent
      },
      {
        path: 'careteam',
        component: CareTeamComponent
      },
      {
        path: 'covidform',
        component: CovidFormComponent
      },
      {
        path: 'thank-you',
        component: ThankYouComponent
      },
      {
        path: 'consent-form',
        component: ConsentformComponent
      },
      {
        path: 'financial-form',
        component: FinancialFormComponent
      },
      {
        path: 'visit-reason',
        component: VisitReasonComponent
      },
      {
        path: 'payment-overview',
        component: PaymentOverviewComponent
      },
      {
        path: 'payment',
        component: PaymentComponent
      },
      {
        path: '**', 
        component: VerifyPatientComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
